import * as angular from "angular";
import {ConsolidatedCommissionRequestsService} from "./services/consolidated-commission-requests.service";
import {CommonsService} from "../commons/services/commons-service.service";

angular
  .module('bringoz.admin.commissions')
  .config(commissionsConfig);

/* @ngInject */
function commissionsConfig($stateProvider) {

  $stateProvider

    // Commissions
    .state('commissions', {
      parent: 'bringoz.site',
      url: '/commissions',
      abstract: true,
      template: '<site-commissions-view></site-commissions-view>',
      controller: function (site) {}
    })

    //Commissions - Accounts Summary
    .state('commissions.accounts-summary', {
      url: '/accounts',
      template: '<accounts-commissions-summary-view></accounts-commissions-summary-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Accounts"});
        triBreadcrumbsService.addCrumb({name: "Payments"});
        triBreadcrumbsService.addCrumb({name: "Finance"});
      }
    })

    //Commissions - List
    .state('commissions.list', {
      url: '/list?:statuses&:from&:to&:agentIds&:supplyAccountIds&:accountIds&:isConsolidated&:serviceStatuses',
      template: '<commissions-view from="vm.from" to="vm.to" statuses="vm.statuses" ' +
        'agent-ids="vm.agentIds" supply-account-ids="vm.supplyAccountIds" account-ids="vm.accountIds" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" is-consolidated="vm.isConsolidated" service-statuses="vm.serviceStatuses"></commissions-view>',
      controllerAs: 'vm',
      controller: function ($scope, triBreadcrumbsService, viewFilterSettingsService, $state, commonsService: CommonsService, $stateParams) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.from = parseInt($stateParams.from);
        this.to = parseInt($stateParams.to);
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses);
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || [];
        this.supplyAccountIds = commonsService.parseArrayStateParam($stateParams.supplyAccountIds) || [];
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || [];
        this.serviceStatuses = commonsService.parseArrayStateParam($stateParams.serviceStatuses) || [];
        this.isConsolidated = $stateParams.isConsolidated;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Accounts"});
        triBreadcrumbsService.addCrumb({name: "Payments"});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    //Commissions - Consolidated
    .state('commissions.consolidated', {
      url: '/consolidated/:consolidatedId?:accountId&:filterDateType&:isPaymentFailed',
      template: '<consolidated-commissions-view selected-consolidated-commission="vm.consolidatedCommission" ' +
        'is-payment-failed="vm.isPaymentFailed" filter-date-type="vm.filterDateType">' +
        '</consolidated-commissions-view>',
      controllerAs: 'vm',
      controller: function ($scope, $stateParams, triBreadcrumbsService, $consolidatedCommission, consolidatedCommission) {
        this.consolidatedCommission = consolidatedCommission;
        this.filterDateType = $stateParams.filterDateType;

        this.isPaymentFailed = $stateParams.isPaymentFailed ? JSON.parse($stateParams.isPaymentFailed) : undefined;
        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Consolidated Carrier Commissions"});
        triBreadcrumbsService.addCrumb({name: "Payments"});
        triBreadcrumbsService.addCrumb({name: "Finance"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        consolidatedCommission: function (consolidatedCommissionRequestsService: ConsolidatedCommissionRequestsService, $stateParams, $q, site) {
          return $stateParams.consolidatedId ?
            consolidatedCommissionRequestsService.getOne($stateParams.consolidatedId) :
            $q.when();
        }
      }
    })

}
